import axios from 'axios';

// A mock function to mimic making an async request for data
export async function sendData(payload) {
  const res = await axios.post(process.env.REACT_APP_URL2+'/api/window-sticker/schedule-test-drive', payload);
  console.log('res', res);
  return res.data.response;
}
